import { Loki } from "./loki";
import { Collection } from "./collection";

(Loki as any)["Collection"] = Collection;

export { Loki, Collection };
export default Loki;
